// TeacherItem.js
import React, { useState } from "react";
import { Image, Button, Icon, Confirm, List } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { TeacherForm } from "../TeacherForm";
import { TeacherAPI } from "../../../../api";
import { useTranslation } from "react-i18next";
import "./TeacherItem.scss";

const teacherController = new TeacherAPI();

export function TeacherItem(props) {
  const { teacher, onReload, accessToken } = props;
  const { t } = useTranslation("teachers");

  // --- Estados para los modales ---
  const [showModal, setShowModal] = useState(false);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const [showConfirm, setShowConfirm] = useState(false);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  // 👇 **NUEVO ESTADO para el modal de roles**
  const [showRolesModal, setShowRolesModal] = useState(false);
  const onOpenCloseRolesModal = () =>
    setShowRolesModal((prevState) => !prevState);
  // ---------------------------------

  const onDelete = async () => {
    try {
      await teacherController.deleteTeacher(accessToken, teacher._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log(error);
    }
  };

  // --- Lógica para la visualización de roles ---
  const roles = teacher.classrole || [];
  const hasManyRoles = roles.length > 2;
  const rolesToShow = hasManyRoles ? roles.slice(0, 2) : roles;
  const remainingRolesCount = roles.length - 2;
  // -------------------------------------------

  return (
    <>
      <div className="teacher-item">
        <div className="teacher-item__image">
          <Image src={teacher.avatar || "default-avatar.png"} />
        </div>

        <div className="teacher-item__content">
          <div className="teacher-item__info-title">
            <h2>
              {teacher.firstname} {teacher.lastname}
            </h2>
          </div>
          <div className="teacher-item__info-path">
            <p>{teacher.email}</p>
          </div>

          {/* 👇 **SECCIÓN DE ROLES ACTUALIZADA** 👇 */}
          <div className="teacher-item__classrole">
            {roles.length > 0 ? (
              <>
                {rolesToShow.map((roleItem, index) => (
                  <div key={index} className="teacher-item__classrole-item">
                    <p>
                      <strong>{roleItem.classnumber}</strong> - {roleItem.role}
                    </p>
                  </div>
                ))}
                {hasManyRoles && (
                  <p
                    className="teacher-item__roles-more-button"
                    onClick={onOpenCloseRolesModal}
                  >
                    +{remainingRolesCount} {t("item.moreRoles")}
                  </p>
                )}
              </>
            ) : (
              <p className="teacher-item__no-roles">{t("item.noRoles")}</p>
            )}
          </div>
          {/* --------------------------------- */}

          <div className="teacher-item__buttons">
            <Button icon primary onClick={onOpenCloseModal}>
              <Icon name="pencil" />
            </Button>
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      </div>

      {/* Modal para editar (sin cambios) */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("item.editLabel")}
        size="small"
      >
        <TeacherForm
          teacher={teacher}
          onClose={onOpenCloseModal}
          onReload={onReload}
        />
      </BasicModal>

      {/* Confirmación para eliminar (sin cambios) */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`${t("item.deleteConfirm")} ${teacher.firstname}?`}
        size="mini"
      />

      {/* 👇 **NUEVO MODAL para mostrar todos los roles** 👇 */}
      <BasicModal
        show={showRolesModal}
        close={onOpenCloseRolesModal}
        title={`${t("item.rolesModalTitle")} ${teacher.firstname} ${teacher.lastname}`}
        size="tiny"
      >
        <List divided relaxed>
          {roles.map((roleItem, index) => (
            <List.Item key={index}>
              <List.Icon
                name="id badge outline"
                size="large"
                verticalAlign="middle"
              />
              <List.Content>
                <List.Header>{roleItem.classnumber}</List.Header>
                <List.Description>{roleItem.role}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
      </BasicModal>
      {/* --------------------------------- */}
    </>
  );
}
